// extracted by mini-css-extract-plugin
module.exports = {"bannerPic":"bannerPic-1Pd7fkla","current":"current-10ixMDAO","pic_img":"pic_img-2Vk_aQaS","trans":"trans-2WKmovAS","text":"text-3p2sb6sW","title":"title-3IxHZdOf"};